import React from "react";

import { mobileScreenType } from "@stadium/constants";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { appendBackgroundImage } from "@sendmagic/prismic-nextjs/src/helpers/images";

// import "./styles/TextOnlyBanner.module.scss";

const DefaultVariationSection = ({ doc, StartOrderBtn }) => {
  const { primary: { internal_link_id, heading, paragraph_text } = {}, items = [] } = doc;

  return (
    <div className="container mt-4 mt-md-0 snackbox-block text-only-slice-container container-width">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      {checkContentPresence(heading) && (
        <div className="text-theme-primary text-center text-only-slice-title same-size-title font-weight-bold">
          {textResolver(heading)}
        </div>
      )}
      {checkContentPresence(paragraph_text) && (
        <div className="mt-3 mt-2xl-3 sns-h4 text-center px-lg-5 px-2xl-5 mx-lg-5 mx-2xl-5 detail-text content-block-description paragraph-spacing">
          {textResolver(paragraph_text)}
        </div>
      )}
      <div className="mt-4 mt-2xl-4 text-center text-only-slice-link-row">
        {items.map(({ link, link_text, start_an_order }) =>
          start_an_order && StartOrderBtn ? (
            <StartOrderBtn className="mx-md-2 mx-2xl-2 mb-3 mb-md-0 px-2xl-5 d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing">
              {textResolver(link_text)}
            </StartOrderBtn>
          ) : (
            link?.url && (
              <PrismicLinkTag
                urlText={link_text}
                url={link?.url}
                target={link?.target}
                className="mx-md-2 mx-2xl-2 mb-3 mb-md-0 px-2xl-5 d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing"
              />
            )
          ),
        )}
      </div>
    </div>
  );
};

const DefaultVariation = ({ doc, StartOrderBtn, currentDevice }) => {
  const { primary: { desktop_bg_image, mobile_bg_image, background_color } = {} } = doc;

  const isMobileView = currentDevice === mobileScreenType;

  const sectionDeskTopStyle = {
    ...appendBackgroundImage(desktop_bg_image?.url),
    backgroundColor: background_color,
  };

  return (
    <>
      {isMobileView ? (
        <div className="text-only-next">
          <div
            className="pt-4 pt-2xl-4 pb-4 pb-2xl-4 text-only-slice prismic-slice"
            style={sectionDeskTopStyle}
          >
            <div className="text-center text-only-slice-mobile-image">
              <PrismicImgix
                className="img-responsive img-responsive-height"
                src={mobile_bg_image?.url}
                alt={mobile_bg_image?.alt}
                desktop="320px"
                mobile="250px"
                tablet="240px"
                largeDisplay="700px"
              />
            </div>
            <DefaultVariationSection doc={doc} StartOrderBtn={StartOrderBtn} />
          </div>
        </div>
      ) : (
        <div className="text-only">
          <div
            className="py-md-5 py-2xl-5 py-5 py-2xl-5 container-width text-only-slice default-slice prismic-slice"
            style={sectionDeskTopStyle}
          >
            <DefaultVariationSection doc={doc} StartOrderBtn={StartOrderBtn} />
          </div>
        </div>
      )}
    </>
  );
};

export default DefaultVariation;
